import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import MemberForumThreadPage from "@/pages/member/MemberForumThreadPage";

export const Route = createFileRoute("/member/forums/thread/$threadId")({
  head: () => pageHead("Member · Forums · Thread", "AKIVA member · forums · thread portal.", "/member/forums/thread/$threadId", true),
  component: MemberForumThreadPage,
});
